import { isDefinedArray, reduce } from "et3-type-guards";
import Et3Button from "../../../../../core/et3-button";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getSupervisorReceiptStore from "../../../../../stores/supervisor-store/supervisor-receipt-compensation-store";
import { currentMonthSupervisorArray } from "../../../../../helpers/et3-receipt-compensation-and-calculation/supervisor-receipt-helpers";

const SubmitFinalReceipt = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const showSubmitButton = isDefinedArray(
    reduce(() => currentMonthSupervisorArray(), [])
  );

  return !showSubmitButton ? null : (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="flex-end"
      withShadow={false}
      width={300}
      height={110}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Button
        onClick={async () => {
          await getSupervisorReceiptStore().submitSupervisorCurrentMonthReceipt();
        }}
        isEnabled={getSupervisorReceiptStore().submitButtonEnabled.get()}
        size="LARGE"
        text="SUBMIT"
        type="GET"
      />
    </ET3Div>
  );
});
export default SubmitFinalReceipt;
